type Props = {
  fill?: string;
  height?: number;
  width?: number;
};

export function OpenQuoteMark({
  width = 32,
  height = 32,
  fill = '#000000'
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 0V2.10286C15.2099 2.22476 14.5634 2.52952 14.0606 3.01714C13.5937 3.47429 13.2346 4.05333 12.9832 4.75429C12.7677 5.45524 12.6599 6.21714 12.6599 7.04H15.5152V12.3429H9.53535V7.54286C9.53535 5.77524 9.84063 4.37333 10.4512 3.33714C11.0976 2.30095 11.9057 1.52381 12.8754 1.00571C13.881 0.487619 14.9226 0.152381 16 0ZM6.46465 0V2.10286C5.67452 2.22476 5.02806 2.52952 4.52525 3.01714C4.05836 3.47429 3.69921 4.05333 3.44781 4.75429C3.23232 5.45524 3.12458 6.21714 3.12458 7.04H5.9798V12.3429H0V7.54286C0 5.77524 0.305275 4.37333 0.915825 3.33714C1.56229 2.30095 2.37037 1.52381 3.34007 1.00571C4.34568 0.487619 5.38721 0.152381 6.46465 0Z"
        fill={fill}
      />
    </svg>
  );
}

export function CloseQuoteMark({
  width = 32,
  height = 32,
  fill = '#000000'
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12.3437L1.83838e-07 10.2409C0.790123 10.119 1.43659 9.81422 1.93939 9.3266C2.40629 8.86946 2.76543 8.29041 3.01684 7.58946C3.23232 6.88851 3.34007 6.12661 3.34007 5.30375L0.48485 5.30375L0.48485 0.000888422L6.46465 0.000888945L6.46465 4.80089C6.46465 6.56851 6.15937 7.97042 5.54882 9.00661C4.90236 10.0428 4.09428 10.8199 3.12458 11.338C2.11897 11.8561 1.07744 12.1914 0 12.3437ZM9.53535 12.3437L9.53535 10.2409C10.3255 10.119 10.9719 9.81422 11.4747 9.3266C11.9416 8.86946 12.3008 8.29042 12.5522 7.58946C12.7677 6.88851 12.8754 6.12661 12.8754 5.30375L10.0202 5.30375L10.0202 0.000889255L16 0.000889778L16 4.80089C16 6.56851 15.6947 7.97042 15.0842 9.00661C14.4377 10.0428 13.6296 10.8199 12.6599 11.338C11.6543 11.8561 10.6128 12.1914 9.53535 12.3437Z"
        fill={fill}
      />
    </svg>
  );
}
